export const prepareTwoDMapData = (value) => (dispatch) => {
  //console.log("Ashish1");
  return dispatch({
    type: "prepareTwoDMapData",
    payload: value,
  });
};
 export function downloadOnClick (value) {
   return(dispatch)=>{
     dispatch({
       type : "downloadClick",
       payload : value
     })
   }
 }

 export function autoGeneratedPDF (value) {
  return(dispatch)=>{
    dispatch({
      type : "autoGeneratedPDF",
      payload : value
    })
  }
}

export function commonAlert(key)
{
    console.log(key);
    return true;
}

export const generatedTwoDMapData = (value) => (dispatch) => {
  return dispatch({
    type: "generatedTwoDMapData",
    payload: value,
  });
};